/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BaseMedicalHistoryFormComponent from "core/components/medical-history/abstract/base-edition-form";
import { validateNumber } from "ember-changeset-validations/validators";
import MedicalHistoryBaseEditionForm from "../base-edition-form";
export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "MedicalHistoryBaseEditionForm", MedicalHistoryBaseEditionForm);
    _defineProperty(this, "journalEventProperties", [...this.sharedProperties, ...this.renalPathologyProperties, ...this.pulmonaryPathologyProperties]);
  }
  get validations() {
    return {
      creatinineThreeMonthsAfterTransplant: validateNumber({
        gte: 20,
        lte: 2000,
        allowBlank: true,
        description: "La quantité de créatinine après 3 mois"
      })
    };
  }
  get renalPathologyProperties() {
    return ["transplantDate", "transplantRank", "nephropatie", "donorType", "immunologicalRisk", "incompatibleABO", "donorCreatinine", "abmClassification", "creatinineThreeMonthsAfterTransplant", "rejectsFirstYear", "mrcStage", "mrcPreexistingTransplant", "transplantedOrgan", "cytomegalovirusStatus"];
  }
  get pulmonaryPathologyProperties() {
    return ["transplantedOrgan", "underlyingDisease", "transplantDate", "transplantRank", "cytomegalovirusStatus"];
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (!this.isLoadedFromJe) {
      model.transplantedOrgan = null;
    }
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    if (!this.args.patient.isMrc) {
      delete payload.mrcStage;
      delete payload.mrcPreexistingTransplant;
    }
    if (!this.args.patient.isTransplanted) {
      delete payload.transplantedOrgan;
    }
    return payload;
  }
}